import { supabase } from '@/lib/supabase'

export async function fetchUserPushEventEnabled(userId: string, eventType: string): Promise<boolean> {
  const uid = String(userId || '').trim()
  const type = String(eventType || '').trim()
  if (!uid || !type) return true

  const { data, error } = await supabase
    .from('user_push_event_preferences')
    .select('enabled')
    .eq('user_id', uid)
    .eq('event_type', type)
    .maybeSingle()

  if (error && (error as any).code !== 'PGRST116') {
    throw error
  }

  if (!data) return true
  return Boolean((data as any).enabled)
}

export async function upsertUserPushEventEnabled(userId: string, eventType: string, enabled: boolean): Promise<boolean> {
  const uid = String(userId || '').trim()
  const type = String(eventType || '').trim()
  if (!uid || !type) return true

  const { data, error } = await supabase
    .from('user_push_event_preferences')
    .upsert(
      {
        user_id: uid,
        event_type: type,
        enabled: !!enabled,
      } as any,
      { onConflict: 'user_id,event_type' },
    )
    .select('enabled')
    .maybeSingle()

  if (error) {
    throw error
  }

  return Boolean((data as any)?.enabled)
}

